document.addEventListener('DOMContentLoaded', () => {
  const filterContainer = document.getElementById('road-name-filter')

  let filterButtons = filterContainer.querySelectorAll('[data-filter-button]')
  let collectionLists = document.querySelectorAll('[data-road-initial]')


  let availableLetters = new Set();
  collectionLists.forEach(list => {
    availableLetters.add(list.dataset.roadInitial.toLowerCase());
  });

  filterButtons.forEach(button => {
    const filter = button.dataset.filterButton.toLowerCase();
    if (filter !== 'all' && !availableLetters.has(filter)) {
      button.disabled = true;
      button.classList.add('disabled')
    }

  });

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.dataset.filterButton.toLowerCase();
      filterButtons.forEach(btn => {
        btn.classList.remove('active')
      });
      button.classList.add('active');

      if (filter === 'all') {
        collectionLists.forEach(list => {
          list.style.display = '';
        });
      } else {
        collectionLists.forEach(list => {
          if (list.dataset.roadInitial.toLowerCase() === filter){
            list.style.display = '';
          } else {
            list.style.display = 'none';
          }
        });
      }
    })
  })

})
